import React from "react";
import CIS_Logo from "img/logos/CIS_SB_Logo_1.png";
import IEEE_Logo from "img/logos/IEEE_SB_Logo.png";
import { Link } from "react-router-dom";
import Burger from "./Burger";
import NavLinks from "./NavLinks";

function Nav() {
  return (
    <nav className="w-full h-36 z-10 shadow-lg md:fixed bg-white">
      <div
        id="outer-container"
        className="relative w-11/12 mx-auto px-3 h-full grid grid-cols-2 grid-rows-2 lg:w-11/12 2xl:w-10/12 md:flex md:items-center md:justify-between ">
        <Burger
          className="burger-menu"
          pageWrapId={"page-wrap"}
          outerContainerId={"outer-container"}
        />
        <Link to={"/"}>
          <img
            className="cis_logo transition hover:scale-105 cursor-pointer absolute top-3 right-1 md:static w-40 md:w-52 lg:w-60 xl:w-72 lg:m-0"
            src={CIS_Logo}
            alt="CIS_Logo"
          />
        </Link>
        <NavLinks />
        <Link to={"https://www.society.jfn.ac.lk/ieee/"}>
          <img
            className="ieee_logo hidden md:block cursor-pointer md:w-32 lg:w-38 xl:w-40"
            src={IEEE_Logo}
            alt="IEEE_Logo"
          />
        </Link>
      </div>
    </nav>
  );
}

export default Nav;
